import React from "react";
import "./ServiceHeroSection.css";
import {
  FaLaptopCode,
  FaBullseye,
  FaCameraRetro,
  FaBriefcase,
} from "react-icons/fa";

const ServiceHeroSection = () => {
  return (
    <section className="service-hero-section">
      <div className="gradient-layer"></div>

      <div className="hero-content">
        <h1 className="hero-heading">
          One Stop Destination for Every Career & Digital Need.
        </h1>

        <p className="hero-subtext">
          At <span className="highlight">MBR Network’s</span>, we believe in
          creating complete transformations — whether it’s your career growth or
          your digital presence. From <strong>web & app development</strong> to{" "}
          <strong>personalized mentorship</strong>
          and <strong>job placement</strong>, we help individuals and businesses
          reach their goals with confidence and clarity.
        </p>

        <h3 className="hero-tagline">
          “Your Dream Career and Digital Success Start Here.”
        </h3>

        <div className="hero-icons">
          <div className="icon-box">
            <FaLaptopCode />
          </div>
          <div className="icon-box">
            <FaBullseye />
          </div>
          <div className="icon-box">
            <FaCameraRetro />
          </div>
          <div className="icon-box">
            <FaBriefcase />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceHeroSection;
